import { render, staticRenderFns } from "./Overlay.vue?vue&type=template&id=2bf2ff4c&scoped=true&lang=pug&"
import script from "./Overlay.vue?vue&type=script&lang=js&"
export * from "./Overlay.vue?vue&type=script&lang=js&"
import style0 from "./Overlay.vue?vue&type=style&index=0&id=2bf2ff4c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf2ff4c",
  null
  
)

export default component.exports